import { Outlet } from "react-router-dom";

import KazaarTemplateImage from "@/assets/img/kazaar-default-screen.webp";
import KazaarLogo from "@/assets/logos/kazaar_logo_white.svg";
import { AuthenticateGuard } from "@/components/AuthenticateGuard";

import { LanguageSelect } from "./_partials/LanguageSelect";

export const AuthLayout = () => {
  return (
    <AuthenticateGuard>
      {/* TODO: This way to do probably must remplace the component KazaarTemplate, to discuss with front team */}
      <div className="flex h-screen w-screen items-center bg-bg-main">
        <div className="relative flex h-full w-full items-center justify-center">
          <div className="absolute right-sp-xl2 top-sp-xl2">
            <LanguageSelect />
          </div>
          <div className="flex w-full justify-center p-sp-xl">
            <div className="flex w-full max-w-[480px] flex-col gap-sp-xl rounded-br-lg bg-elevation-first p-sp-xl2">
              <Outlet />
            </div>
          </div>
        </div>

        <div
          className="flex h-screen w-1/2 overflow-hidden bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${KazaarTemplateImage})` }}
        >
          <div className="flex w-full items-start justify-center">
            <img src={KazaarLogo} alt="" className="mt-[160px] max-w-[50%]" />
          </div>
        </div>
      </div>
    </AuthenticateGuard>
  );
};
